import classNames from 'classnames/bind';

import { ComponentType } from 'pipelines/services/rete/nodes/component';
import { usePlanIncludedNodeTypesState } from 'pipelines/context/planIncludedNodesStore';
import { PricingPlanLabel } from '../PricingPlanLabel/PricingPlanLabel';

import styles from './EditorNode.module.scss';

const c = classNames.bind(styles);

export type EditorNodePricingPlanLabelProps = {
  Component: ComponentType;
};

export function EditorNodePricingPlanLabel({
  Component,
}: EditorNodePricingPlanLabelProps) {
  const { includedNodeTypes } = usePlanIncludedNodeTypesState();

  if (!Component || Component.status === 'deprecated') {
    return null;
  }

  // If includedNodes is undefined or null (loading or no plan), don't show label
  // If includedNodes is defined, check if the node is included
  if (includedNodeTypes === undefined || includedNodeTypes === null) {
    return null;
  }

  const isNodeIncluded = includedNodeTypes.has(Component.exportType);

  if (isNodeIncluded) {
    return null;
  }

  return <PricingPlanLabel className={c('plan-label')} />;
}
